module.exports = __webpack_public_path__ + "static/media/background-unsplash-karsten-wurth.ff9b81fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-unsplash-karsten-wurth.jpg
// module id = 1747
// module chunks = 0